module.exports = __webpack_public_path__ + "static/media/interreg-euregio-mr-vertical.a18bfcd7.png";